import { useState } from "react";
import { BRAND } from "../constants/brand";
import PageHero from "../components/PageHero";

const API_URL = process.env.REACT_APP_CHAT_API_URL || "";

export default function MakeAnAppointmentPage() {
  const [form, setForm] = useState({ firstName: "", lastName: "", dob: "", phone: "", email: "", provider: "", testType: "", preferredDate: "", preferredTime: "", notes: "" });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = e => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      await fetch(`${API_URL}/api/appointment`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...form, subject: "Appointment Request", type: "appointment" }),
      });
    } catch {}
    setLoading(false);
    setSubmitted(true);
  };

  const inputStyle = { width: "100%", padding: "12px 14px", border: `1.5px solid ${BRAND.lightGray}`, borderRadius: 8, fontFamily: "'Barlow', sans-serif", fontSize: 14, color: BRAND.textDark, outline: "none", background: BRAND.offWhite, boxSizing: "border-box" };
  const labelStyle = { display: "block", fontFamily: "'Barlow', sans-serif", fontSize: 11, fontWeight: 700, letterSpacing: "0.15em", color: BRAND.navy, marginBottom: 6 };

  return (
    <>
      <PageHero eyebrow="PATIENTS" title="Make an" highlight="Appointment" subtitle="Schedule your laboratory appointment. Fill out the form and our team will confirm within one business day." />

      <div className="rx-pad" style={{ background: BRAND.offWhite, padding: "72px 32px 96px" }}>
        <div style={{ maxWidth: 1280, margin: "0 auto" }}>
          <div className="appt-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1.6fr", gap: 48 }}>

            {/* Info panel */}
            <div>
              <div style={{ fontFamily: "'Barlow', sans-serif", fontSize: 11, fontWeight: 700, letterSpacing: "0.22em", color: BRAND.gold, marginBottom: 16 }}>CONTACT INFORMATION</div>
              {/* Draw station card replaced with Labarium HQ details
              Old: Milledgeville Location with draw station hours
              */}
              <div style={{ background: BRAND.navy, borderRadius: 16, padding: "36px", marginBottom: 24, position: "relative", overflow: "hidden" }}>
                <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 3, background: BRAND.gold }} />
                <h3 style={{ fontFamily: "'Playfair Display', serif", fontWeight: 700, fontSize: 24, color: BRAND.white, margin: "0 0 20px" }}>Labarium Diagnostic Systems</h3>
                {[
                  ["Corporate Headquarters", "495 Grand Blvd #206\nMiramar Beach, FL 32550"],
                  ["Toll-Free", "(877) 765-2274"],
                  ["Phone", "(850) 460-1484"],
                  ["Email", "info@labarium.com"],
                  ["Customer Service", "Monday–Friday\n8:00 AM – 5:30 PM"],
                ].map(([label, value]) => (
                  <div key={label} style={{ marginBottom: 16, paddingBottom: 16, borderBottom: "1px solid rgba(255,255,255,0.07)" }}>
                    <div style={{ fontFamily: "'Barlow', sans-serif", fontSize: 10, fontWeight: 700, letterSpacing: "0.2em", color: BRAND.gold, marginBottom: 4 }}>{label.toUpperCase()}</div>
                    <div style={{ fontFamily: "'Barlow', sans-serif", fontSize: 14, color: "rgba(255,255,255,0.85)", lineHeight: 1.6, whiteSpace: "pre-line" }}>{value}</div>
                  </div>
                ))}
              </div>

              <div style={{ background: BRAND.white, borderRadius: 16, border: `1px solid ${BRAND.lightGray}`, padding: "28px", boxShadow: "0 4px 20px rgba(0,53,122,0.06)" }}>
                <h4 style={{ fontFamily: "'Playfair Display', serif", fontWeight: 700, fontSize: 18, color: BRAND.navy, margin: "0 0 16px" }}>What to Bring</h4>
                {["Valid government-issued photo ID", "Insurance card(s)", "Lab requisition form from your doctor", "List of current medications (if applicable)", "Payment method for any copays"].map(item => (
                  <div key={item} style={{ display: "flex", gap: 10, marginBottom: 10, alignItems: "flex-start" }}>
                    <div style={{ width: 6, height: 6, borderRadius: "50%", background: BRAND.gold, flexShrink: 0, marginTop: 5 }} />
                    <span style={{ fontFamily: "'Barlow', sans-serif", fontSize: 13, color: BRAND.textMid, lineHeight: 1.6 }}>{item}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Appointment form */}
            <div>
              <div style={{ fontFamily: "'Barlow', sans-serif", fontSize: 11, fontWeight: 700, letterSpacing: "0.22em", color: BRAND.gold, marginBottom: 16 }}>APPOINTMENT REQUEST</div>
              <div style={{ background: BRAND.white, borderRadius: 16, border: `1px solid ${BRAND.lightGray}`, overflow: "hidden", boxShadow: "0 4px 20px rgba(0,53,122,0.06)" }}>
                <div style={{ background: BRAND.navy, padding: "24px 32px", position: "relative" }}>
                  <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 3, background: BRAND.gold }} />
                  <h2 style={{ fontFamily: "'Playfair Display', serif", fontWeight: 700, fontSize: 24, color: BRAND.white, margin: "0 0 4px" }}>Schedule Your Visit</h2>
                  <p style={{ fontFamily: "'Barlow', sans-serif", fontSize: 13, color: "rgba(255,255,255,0.6)", margin: 0 }}>We'll confirm your appointment within one business day</p>
                </div>
                <div style={{ padding: "32px" }}>
                  {submitted ? (
                    <div style={{ textAlign: "center", padding: "48px 20px" }}>
                      <div style={{ width: 64, height: 64, borderRadius: "50%", background: "rgba(0,53,122,0.08)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px" }}>
                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none"><path d="M20 6L9 17l-5-5" stroke={BRAND.navy} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                      </div>
                      <h3 style={{ fontFamily: "'Playfair Display', serif", fontWeight: 700, fontSize: 24, color: BRAND.navy, marginBottom: 12 }}>Request Received!</h3>
                      <p style={{ fontFamily: "'Barlow', sans-serif", fontSize: 14, color: BRAND.textMid, lineHeight: 1.7 }}>We'll confirm your appointment within one business day. If you need immediate assistance, call us at (877) 765-2274.</p>
                    </div>
                  ) : (
                    <form onSubmit={handleSubmit}>
                      <div className="form-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 }}>
                        {[["firstName", "First Name"], ["lastName", "Last Name"]].map(([name, label]) => (
                          <div key={name}>
                            <label style={labelStyle}>{label.toUpperCase()} *</label>
                            <input name={name} required value={form[name]} onChange={handleChange} style={inputStyle}
                              onFocus={e => e.target.style.borderColor = BRAND.navy}
                              onBlur={e => e.target.style.borderColor = BRAND.lightGray} />
                          </div>
                        ))}
                      </div>
                      <div className="form-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 }}>
                        <div>
                          <label style={labelStyle}>DATE OF BIRTH *</label>
                          <input type="date" name="dob" required value={form.dob} onChange={handleChange} style={inputStyle}
                            onFocus={e => e.target.style.borderColor = BRAND.navy}
                            onBlur={e => e.target.style.borderColor = BRAND.lightGray} />
                        </div>
                        <div>
                          <label style={labelStyle}>PHONE NUMBER *</label>
                          <input type="tel" name="phone" required value={form.phone} onChange={handleChange} style={inputStyle}
                            onFocus={e => e.target.style.borderColor = BRAND.navy}
                            onBlur={e => e.target.style.borderColor = BRAND.lightGray} />
                        </div>
                      </div>
                      <div style={{ marginBottom: 16 }}>
                        <label style={labelStyle}>EMAIL ADDRESS *</label>
                        <input type="email" name="email" required value={form.email} onChange={handleChange} style={inputStyle}
                          onFocus={e => e.target.style.borderColor = BRAND.navy}
                          onBlur={e => e.target.style.borderColor = BRAND.lightGray} />
                      </div>
                      <div style={{ marginBottom: 16 }}>
                        <label style={labelStyle}>ORDERING PROVIDER</label>
                        <input name="provider" value={form.provider} onChange={handleChange} placeholder="Name of your ordering physician" style={inputStyle}
                          onFocus={e => e.target.style.borderColor = BRAND.navy}
                          onBlur={e => e.target.style.borderColor = BRAND.lightGray} />
                      </div>
                      <div style={{ marginBottom: 16 }}>
                        <label style={labelStyle}>TYPE OF TEST / REASON FOR VISIT</label>
                        <input name="testType" value={form.testType} onChange={handleChange} placeholder="e.g. Blood work, Urinalysis, Drug screen..." style={inputStyle}
                          onFocus={e => e.target.style.borderColor = BRAND.navy}
                          onBlur={e => e.target.style.borderColor = BRAND.lightGray} />
                      </div>
                      <div className="form-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 }}>
                        <div>
                          <label style={labelStyle}>PREFERRED DATE</label>
                          <input type="date" name="preferredDate" value={form.preferredDate} onChange={handleChange} style={inputStyle}
                            onFocus={e => e.target.style.borderColor = BRAND.navy}
                            onBlur={e => e.target.style.borderColor = BRAND.lightGray} />
                        </div>
                        <div>
                          <label style={labelStyle}>PREFERRED TIME</label>
                          <select name="preferredTime" value={form.preferredTime} onChange={handleChange} style={{ ...inputStyle, cursor: "pointer" }}>
                            <option value="">Select a time</option>
                            <option value="8:30 AM – 9:00 AM">8:30 AM – 9:00 AM</option>
                            <option value="9:00 AM – 10:00 AM">9:00 AM – 10:00 AM</option>
                            <option value="10:00 AM – 11:00 AM">10:00 AM – 11:00 AM</option>
                            <option value="11:00 AM – 12:00 PM">11:00 AM – 12:00 PM</option>
                            <option value="12:00 PM – 1:00 PM">12:00 PM – 1:00 PM</option>
                            <option value="1:00 PM – 2:00 PM">1:00 PM – 2:00 PM</option>
                            <option value="2:00 PM – 3:00 PM">2:00 PM – 3:00 PM</option>
                            <option value="3:00 PM – 3:45 PM">3:00 PM – 3:45 PM</option>
                          </select>
                        </div>
                      </div>
                      <div style={{ marginBottom: 24 }}>
                        <label style={labelStyle}>ADDITIONAL NOTES</label>
                        <textarea name="notes" rows={3} value={form.notes} onChange={handleChange} placeholder="Any special instructions or notes..." style={{ ...inputStyle, resize: "vertical" }}
                          onFocus={e => e.target.style.borderColor = BRAND.navy}
                          onBlur={e => e.target.style.borderColor = BRAND.lightGray} />
                      </div>
                      <button type="submit" disabled={loading} style={{ width: "100%", background: loading ? BRAND.textMid : BRAND.navy, color: BRAND.white, border: "none", fontFamily: "'Barlow', sans-serif", fontWeight: 700, fontSize: 13, letterSpacing: "0.12em", padding: "16px 24px", borderRadius: 10, cursor: loading ? "not-allowed" : "pointer" }}>
                        {loading ? "SUBMITTING…" : "REQUEST APPOINTMENT →"}
                      </button>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
